// extracted by mini-css-extract-plugin
export default {"recos":"x4-z","productCardOverride":"y4-z","rowHasBadge":"z4-z"};